import React from "react";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
import { Steps } from "antd";
import {
  InfoCircleOutlined,
  DollarCircleOutlined,
  PieChartOutlined,
  BookOutlined,
  ClockCircleOutlined,
  CalculatorOutlined,
  ClusterOutlined,
} from "@ant-design/icons";

const { Step } = Steps;

const stepStyle = {
  boxShadow: "0px -1px 0 0 #e8e8e8 inset",
};

const RenderSteps = (props) => {
  return (
    <Steps
      type="navigation"
      size="small"
      direction="horizontal"
      current={props.currentStepStore}
      onChange={(step) => {
        props.stepRef.current = step;
        props.setCurrentStepStore(step);
      }}
      style={(stepStyle, { flex: 14 })}
      className="ant-steps"
    >
      <Step status="finish" title="Introduction" icon={<InfoCircleOutlined style={{ color: "#d6001c" }} />} />
      <Step status="process" title="Retraining Costs" icon={<BookOutlined style={{ color: "#d6001c" }} />} />
      <Step
        status="process"
        title="Productivity Loss Costs"
        icon={<ClockCircleOutlined style={{ color: "#d6001c" }} />}
      />
      <Step status="process" title="System Change Costs" icon={<ClusterOutlined style={{ color: "#d6001c" }} />} />
      <Step status="finish" title="Benefits" icon={<DollarCircleOutlined style={{ color: "#d6001c" }} />} />
      <Step status="finish" title="Adjusted Costs" icon={<CalculatorOutlined style={{ color: "#d6001c" }} />} />

      <Step status="finish" title="Summary" icon={<PieChartOutlined style={{ color: "#d6001c" }} />} />
    </Steps>
  );
};

const mapStateToProps = (state) => {
  return {
    currentStepStore: state.status.currentStep,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentStepStore: (currentStepStore) => dispatch(actions.setCurrentStep(currentStepStore)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RenderSteps);
